import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import hexToRgba from 'hex-to-rgba'

import SelectOneModel, { NULL as SelectOneModelNULL } from './model'
import inlineStyles from './inlineStyles'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'
import { getValueOrDefault, getValueOrDefaultText } from '@client/utils/getValueOrDefault'
import { defaultText } from './constants'

import './../styles.scss'

export const SelectOne = ({
  model = SelectOneModelNULL,
  editor = EditorModelNULL,
  app = AppModelNULL,
  serverRender = false,
}) => {
  const globalSettings = editor.settings.values
  const settings = model.settings.values
  const isRequired = settings.isRequired || false
  const question = getValueOrDefaultText(
    settings.question,
    defaultText.question
  )
  const hasHelpText = settings.hasHelpText || false
  const helpText = getValueOrDefaultText(
    settings.helpText,
    defaultText.helpText
  )
  return (
    <div
      data-type={BLOCK_TYPES.FIELD}
      data-field-type={FIELD_TYPES.SHORT_TEXT}
      className={`gan-field ${isRequired ? 'gan-field-required' : ''}`}
    >
      <label
        style={{
          ...inlineStyles.label,
          color: globalSettings.normalText_color,
          fontFamily: globalSettings.normalText_fontFamily,
        }}
      >
        {question}
      </label>
      {hasHelpText && (
        <span
          className="help-text"
          style={{
            fontFamily: globalSettings.normalText_fontFamily,
          }}
        >
          {helpText}
        </span>
      )}
      <div>
        {(settings.choices || []).map((item, index) => (
          <label
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: `${globalSettings.normalText_fontSize}px`,
              lineHeight: globalSettings.normalText_lineHeight,
              fontFamily: globalSettings.normalText_fontFamily,
            }}
          >
            <input
              type="radio"
              className="border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-offset-0 focus:ring-indigo-200 focus:ring-opacity-50"
              style={{
                fontSize: `16px`,
                color: hexToRgba(globalSettings.themeColor, 1),
                '--tw-ring-color': hexToRgba(globalSettings.themeColor, 1).replace('1)', 'var(--tw-ring-opacity))'),
              }}
              name={model.inputName}
              value={item.value}
              required={isRequired}
              tabIndex="0"
            />
            <span
              style={{
                marginLeft: '10px',
                color: globalSettings.normalText_color,
              }}
            >
              {getValueOrDefault(
                item.label,
                'fields.answer.default',
                app.formatMessage,
                true
              )}
            </span>
          </label>
        ))}
      </div>
      <div
        className="gan-validation-field-error"
        style={{
          color: 'red',
          fontSize: `${
            globalSettings.normalText_fontSize * 0.7
          }px`,
        }}
      />
    </div>
  )
}

SelectOne.propTypes = {
  model: PropTypes.instanceOf(SelectOneModel),
  editor: PropTypes.instanceOf(EditorModel),
  app: PropTypes.instanceOf(AppModel),
  serverRender: PropTypes.bool,
}

export default inject('editor', 'serverRender', 'app')(observer(SelectOne))
